import { Locale } from '../../domain/Translation';
import { DEFAULT_LOCALE } from '../../config/constants';

export const getLocaleUrl = (route: string, locale: Locale) =>
  route.replace(':locale', locale ?? DEFAULT_LOCALE);

export const getListName = (route: String) => {
  if (!route.includes('admin')) {
    return '';
  }

  const parts = location.pathname.split('/');
  return parts[parts.findIndex((part) => part === 'admin') + 1];
};
